import type { FC} from 'react';
import { useEffect } from 'react';
import { Box, Dialog, DialogContent } from '@mui/material';

import type { File } from '@/types/file';

interface ViewQuoteDialogProps {
  open: boolean;
  onClose: () => void;
  file: File | null;
}

const ViewQuoteDialog: FC<ViewQuoteDialogProps> = (props) => {
  const { open, onClose, file } = props;
  const isPdf = file?.mime_type === 'pdf';

  if (!file) return null;

  return (
    <Dialog fullWidth maxWidth="lg" onClose={onClose} open={open}>
      <DialogContent>
        <Box position="relative">
          {isPdf ? (
            <iframe
              height="350px"
              src={file.path}
              style={{ height: '90vh', width: '100%' }}
              title={file.name}
              width="350px"
            />
          ) : (
            <img
              alt={file.name}
              src={file.path}
              style={{
                display: 'block',
                width: '100%',
                height: 'auto',
              }}
            />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ViewQuoteDialog;
